<template>
	<div v-if="type" class="c-article-state-indicator flex flex-col gap-1">
		<template v-if="(type === CtaButtonType.DEFAULT || type === CtaButtonType.ONLINE || type === CtaButtonType.REDIRECT || type === CtaButtonType.CATEGORY_ONLINE) && ctaStates?.onlineState?.availabilityState?.state">
			<div v-if="!ctaStates?.onlineState?.availabilityState?.textForm.includes('undefined')" class="relative state-indicator">
				<i :class="'stateIcon ' + ctaStates?.onlineState?.availabilityState?.state"/>
				<div class="pointText">{{ ctaStates?.onlineState?.availabilityState?.textForm }}</div>
			</div>
		</template>
		<template v-if="(type === CtaButtonType.DEFAULT || type === CtaButtonType.STORE) && ctaStates?.storeState?.availabilityState?.state">
			<div v-if="!ctaStates?.storeState?.availabilityState?.textForm.includes('undefined')" class="relative state-indicator">
				<i :class="'stateIcon ' + ctaStates?.storeState?.availabilityState?.state"/>
				<div class="pointText">{{ ctaStates?.storeState?.availabilityState?.textForm }}</div>
      		</div>
		</template>
	</div>
</template>
<script setup lang="ts">
import { CtaButtonType, type CtaButtonState } from '~~/models/CTA/CtaButton';

interface Props {
  ctaStates: CtaButtonState
  type?: CtaButtonType;
}

withDefaults(defineProps<Props>(), {
  type: CtaButtonType.DEFAULT,
});
</script>
